import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import * as DateFns from 'date-fns';

import Table, { RowType, HeadsType } from '../../Shared/CustomTable';
import ElapsedTime from '../ElapsedTime';
import PracticeProgress from '../PracticeProgress';
import ConfirmationModal from '../../Shared/Modals/ConfirmationModal';

import { getTeamData } from '../../../helpers/helpers';
import { LIVE } from '../../../config/constants';
import { useRouter } from '../../../helpers/customHooks';
import { useMonitorDispatch } from '../../../store/hooks/monitor';
import { MonitorTable, Monitor } from '../types';
import { TeamData } from '../../../config/commonTypes';

const headers: HeadsType<string> = [
  { content: 'TEAM', class: 't-ll', style: { width: '90px', textAlign: 'center' } },
  { content: 'SITE', class: 't-ll', style: { width: '175px' } },
  { content: 'PRACTICE NAME', class: 't-ll', style: { width: '200px' } },
  { content: 'CURRENT PERIOD', class: 't-ll', style: { width: '135px' } },
  { content: 'START', class: 't-ll', style: { width: '115px' } },
  { content: 'END', class: 't-ll', style: { width: '115px' } },
  { content: 'TOTAL ELAPSED', class: 't-ll', style: { width: '115px' } },
  { content: 'PROCESSING STATUS', style: { width: '235px' } },
  { content: 'REVIEW', style: { width: '96px', textAlign: 'right' } }
];

export default ({ monitorData = [], setModalShow } : MonitorTable) => {

  const { pathname } = useRouter();
  const { checkReviewMonitor } = useMonitorDispatch();

  const [checked, setChecked] = useState<number | string>(-1);

  const modalClose = () => {
    setModalShow(null);
    setChecked(-1);
  };

  const handleDeleteConfirmation = (data: Monitor) => {
    checkReviewMonitor(data);
  };

  const confirmationModalConfig = {
    modalClassName: 'modal-monitor-confirmation-review-by',
    actionsClassName: 'modal-actions',
    confirmClassName: 'confirm-button'
  };

  const confirmationModalContent = {
    headerContent: 'Review Practice',
    bodyContent: (<p>
      <span>By reviewing this Practice Schedule you agree that this scheduled venue and other game components like entities, 
        players, balls etc are ready for game. We will take your initial for review Practice.</span>
      <br />
      <span style={{ color: 'rgb(239, 154, 154)' }}>Note: You can&apos;t undo after you Agree.</span>
    </p>),
    confirmContent: 'AGREE',
    cancelContent: 'CANCEL'
  };

  const checkIfTimeHasOverpassed = (data: Monitor) => {
    const { end, start, allData } = data;
    if (allData.status === LIVE) {
      // diference between actual time and practice start time
      const hrsDif = DateFns.differenceInHours(new Date().getTime(), start);
      return hrsDif >=3 && (
        <i
          className="mdi mdi-alert"
          style={{ color: '#D6151C', fontSize: 18 }}
          title="Practice is started. Its been more than 3 hrs and hasn't stopped yet."
        />
      );
    }

    return !Number.isInteger(end) && '-';
  };

  const rows: RowType[] = [];
  monitorData.forEach((data, index) => {
    const teamData = getTeamData(data.allData.homeTeamId) || {} as TeamData;
    rows.push({
      columns: [
        {
          class: 't-ll',
          content: (
            <Link
              to={{
                pathname: `/health/entity`,
                search: `?league=${data.allData.league}&type=${data.allData.type}&teamId=${data.allData.homeTeamId}`,
                state: {
                  toReturn: pathname
                }
              }}>
              <img
                src={`/assets/images/logos/${teamData.teamAbbrName ? teamData.teamAbbrName : 'ZEBRA'}.svg`} alt="" width="30px"
                className=""
              /> </Link>),
          style: { textAlign: 'center' }
        },
        { class: 't-ll', content: data.siteName },
        {
          class: 't-ll',
          content: (
            <Link
              to={{
                pathname: `/view/practice/${data.allData.status === 'future' ? data.id : data.allData.gameId}/manage`,
                state: {
                  toReturn: pathname
                }
              }}>{data.practiceName}</Link>
          ),
          style: { textDecoration: 'underline' }
        },
        {
          class: 't-ll', style: {wordBreak: 'break-word'}, content: <Link
            to={{
              pathname: `/view/practice/${data.allData.status === 'future' ? data.id : data.allData.gameId}/performance/condensed/page`,
              state: {
                toReturn: pathname
              }
            }}>{data.currentPeriod}</Link>
        },
        {
          class: 't-ll',
          content: (Number.isInteger(data.start) ? DateFns.format(new Date(data.start), 'hh:mmaaa') : '-')
        },
        { class: 't-ll', content: checkIfTimeHasOverpassed(data) ? checkIfTimeHasOverpassed(data) : data.end ? DateFns.format(new Date(data.end), 'hh:mmaaa'): "-"},
        {
          class: 't-ll',
          content: <ElapsedTime start={data.start} end={data.end} status={data.allData.status} />
        },
        { content: <PracticeProgress status={data.processingStatus} /> },
        {
          content: (data.reviewedBy ? data.reviewedBy :
            <>
              <input
                className="styled-checkbox" id={`checkbox-monitor-${data.id}`}
                type="checkbox" value={`${data.id}`}
                checked={checked === data.id}
                onChange={() => setChecked(data.id)}
                disabled={DateFns.isFuture(new Date(data.start)) || !Number.isInteger(data.end)}
                onClick={() => setModalShow(<ConfirmationModal
                  show={1} onHide={modalClose}
                  modalConfig={confirmationModalConfig}
                  modalContent={confirmationModalContent}
                  confirmAction={() => handleDeleteConfirmation(data)}
                />)}
              />
              <label htmlFor={`checkbox-monitor-${data.id}`} className="check-l" />
            </>),
          style: { textAlign: 'right' }
        }
      ],
      id: data.id
    });
  });


  return (
    <Table
      classTable="monitor-table"
      headers={headers}
      rows={rows}
    />
  );
};
